const tocDetails = document.querySelector(".toc-details");
const tocSummary = document.querySelector(".toc-summary");
const mediaQery = window.matchMedia("(min-width: 750px)").matches;
const reviewSection = document.querySelector("#judgeme_product_reviews");
addReviewLink();
getDataToc();

const tocLinks = tocDetails.querySelectorAll(".toc-link");
tocLinks.forEach((link) => {
  link.addEventListener("click", function (e) {
    e.preventDefault();
    const targetId = this.getAttribute("href").substring(1);
    const targetElement = document.getElementById(targetId);
    targetElement.scrollIntoView({
      behavior: "smooth",
    });
    if (!mediaQery) {
      tocDetails.open = false;
      document.body.classList.remove("overflow-hidden");
    }
  });
});
tocDetailsOpen();
window.addEventListener("resize", () => {
  tocDetailsOpen();
});
function tocDetailsOpen() {
  if (mediaQery) {
    tocDetails.open = true;
  } else {
    tocDetails.open = false;
  }
}

function addReviewLink() {
  const tocList = tocDetails.querySelector(".toc-list");
  if (reviewSection) {
    const reviewLink = `<li class="list-item" role="listitem"><a href="#judgeme_product_reviews" class="toc-link link">レビュー</a></li>`;
    tocList.insertAdjacentHTML("beforeend", reviewLink);
  }
}

const boxes = document.querySelectorAll(".image-box");
const options = {
  root: null,
  rootMargin: "-50% 0px",
  threshold: 0,
};
const observer = new IntersectionObserver(doWhenIntersect, options);
boxes.forEach((box) => {
  observer.observe(box);
});
if (reviewSection) {
  observer.observe(reviewSection);
}

function doWhenIntersect(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      activateIndex(entry.target);
    }
  });
}

function activateIndex(element) {
  const currentActiveIndex = tocDetails.querySelector(".toc-link.active");
  if (currentActiveIndex !== null) {
    currentActiveIndex.classList.remove("active");
  }
  const newActiveIndex = tocDetails.querySelector(`a[href='#${element.id}']`);
  if (newActiveIndex) {
    newActiveIndex.classList.add("active");
    const indexTitle = tocDetails.querySelector(".toc-summary span");
    indexTitle.textContent = newActiveIndex.textContent;
  }
}

tocSummary.addEventListener("click", function () {
  setTimeout(() => {
    if (tocDetails.open === false) {
      document.body.classList.remove("overflow-hidden");
    } else {
      document.body.classList.add("overflow-hidden");
    }
  }, 200);
});

function getDataToc() {
  const dataToc = document.querySelector("[data-toc]");
  if (!dataToc) return;
  const stickyBuyButton = document.querySelector(".sticky-buy-button");
  if (!stickyBuyButton) return;
  stickyBuyButton.classList.add("toc-true");
}
